import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getMonitoringData } from '../api/monitoringApi';
import storageService from '../services/storage.service';
import { DECODED_ACCESS_TOKEN } from '../constants/system.keys';
import moment from 'moment';

export const useMonitoringDataFetch = (questionId, selectedDate = null) => {
  const { namespace } = useSelector((state) => state);

  const fetchData = useCallback(async () => {
    if (!namespace || !questionId) return null;

    try {
      const token =
        storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);
      const dataQuery = {
        namespace,
        questionId,
      };
      if (selectedDate) {
        dataQuery.date = selectedDate
          ? moment(selectedDate).format('YYYY-MM-DD')
          : moment().format('YYYY-MM-DD');
      }
      const res = await getMonitoringData(token, { namespace }, dataQuery);

      return res?.data?.data || [];
    } catch (err) {
      throw err;
    }
  }, [namespace, questionId, selectedDate]);

  return fetchData;
};
